export const FORMATOS = [
  { label: 'Párrafo', valor: 'p' },
  { label: 'Título 1', valor: 'h1' },
  { label: 'Título 2', valor: 'h2' },
  { label: 'Título 3', valor: 'h3' },
  { label: 'Cita / Cláusula', valor: 'blockquote' },
];

export const INITIAL_FORMATOS_ACTIVOS = {
  bold: false,
  italic: false,
  underline: false,
  strikeThrough: false,
  justifyLeft: false,
  justifyCenter: false,
  justifyRight: false,
  justifyFull: false,
  insertUnorderedList: false,
  insertOrderedList: false,
};

export const INITIAL_CONFIG_TABLA = {
  filas: 3,
  columnas: 2,
  estilo: 'con-bordes',
  conEncabezado: true,
};

export const INITIAL_ESTADISTICAS = {
  palabras: 0,
  caracteres: 0,
  paginas: 1,
};
